import { render } from "./BaseImageWrapper.vue?vue&type=template&id=3d34f7cf"
import script from "./BaseImageWrapper.vue?vue&type=script&lang=js"
export * from "./BaseImageWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__